var baseurl = 'https://img.ving.se/image/upload/web/pins/map/';
var globePin = baseurl.concat('default-globe.png');
var globePinHover = baseurl.concat('hover-globe.png');
var globePinSelected = baseurl.concat('selected-globe.png');
var markerPin = baseurl.concat('default.png');
var markerPinHover = baseurl.concat('hover.png');
var markerPinSelected = baseurl.concat('selected.png');

export { globePin, globePinHover, globePinSelected, markerPin, markerPinHover, markerPinSelected };
//# sourceMappingURL=mapMarkers.js.map
